import { render, staticRenderFns } from "./Threads.vue?vue&type=template&id=600c1e82&"
import script from "./Threads.vue?vue&type=script&lang=js&"
export * from "./Threads.vue?vue&type=script&lang=js&"
import style0 from "./Threads.vue?vue&type=style&index=0&id=600c1e82&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports